/**
 * @flow
 * @relayHash 3ba42be9f1f8428d9ade5bf48da1270b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ProductIssuesTable_project$ref = any;
export type FilterOperator = "AND" | "OR" | "%future added value";
export type TextFilterOperator = "CONTAINS" | "NOT_CONTAINS" | "REGEXP" | "%future added value";
export type TextFilters = {
  operator: FilterOperator,
  values?: ?$ReadOnlyArray<?TextFilter>,
};
export type TextFilter = {
  operator: TextFilterOperator,
  value: string,
};
export type ProductIssuesTable_RefetchQueryVariables = {|
  host: string,
  limit?: ?number,
  offset?: ?number,
  levels?: ?$ReadOnlyArray<string>,
  sourceUrl?: ?TextFilters,
|};
export type ProductIssuesTable_RefetchQueryResponse = {|
  +project: ?{|
    +$fragmentRefs: ProductIssuesTable_project$ref
  |}
|};
export type ProductIssuesTable_RefetchQuery = {|
  variables: ProductIssuesTable_RefetchQueryVariables,
  response: ProductIssuesTable_RefetchQueryResponse,
|};
*/


/*
query ProductIssuesTable_RefetchQuery(
  $host: String!
  $limit: Int
  $offset: Int
  $levels: [String!]
  $sourceUrl: TextFilters
) {
  project(host: $host) {
    ...ProductIssuesTable_project_2KjDti
    id
  }
}

fragment ProductIssuesTable_project_2KjDti on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        productIssues(offset: $offset, limit: $limit, levels: $levels, sourceUrl: $sourceUrl) {
          count
          edges {
            node {
              ...ProductIssuesRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment ProductIssuesRow_issue on ProductIssue {
  id
  source_url
  issue
  level
  name
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "levels",
    "type": "[String!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sourceUrl",
    "type": "TextFilters",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ProductIssuesTable_RefetchQuery",
  "id": null,
  "text": "query ProductIssuesTable_RefetchQuery(\n  $host: String!\n  $limit: Int\n  $offset: Int\n  $levels: [String!]\n  $sourceUrl: TextFilters\n) {\n  project(host: $host) {\n    ...ProductIssuesTable_project_2KjDti\n    id\n  }\n}\n\nfragment ProductIssuesTable_project_2KjDti on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        productIssues(offset: $offset, limit: $limit, levels: $levels, sourceUrl: $sourceUrl) {\n          count\n          edges {\n            node {\n              ...ProductIssuesRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ProductIssuesRow_issue on ProductIssue {\n  id\n  source_url\n  issue\n  level\n  name\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ProductIssuesTable_RefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ProductIssuesTable_project",
            "args": [
              {
                "kind": "Variable",
                "name": "levels",
                "variableName": "levels",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "limit",
                "variableName": "limit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "sourceUrl",
                "variableName": "sourceUrl",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ProductIssuesTable_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "productIssues",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "levels",
                            "variableName": "levels",
                            "type": "[String!]"
                          },
                          {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "sourceUrl",
                            "variableName": "sourceUrl",
                            "type": "TextFilters"
                          }
                        ],
                        "concreteType": "ProductIssueConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "count",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ProductIssueEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ProductIssue",
                                "plural": false,
                                "selections": [
                                  v2,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "issue",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "level",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "name",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v2
                    ]
                  }
                ]
              }
            ]
          },
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '42e09075a73c375158f365109b8a9b18';
module.exports = node;
